import { postRequest } from "./postRequest";

const FEEDBACK_API = process.env.REACT_APP_FEEDBACK_API

 console.log(FEEDBACK_API)
export const postFeedback = (payload) => {
  return postRequest(FEEDBACK_API, payload);
};